export default __webpack_public_path__ + "static/26-12d5693976e84d0fecc484803d8632d6.png";